import MuiSwitch from '@mui/material/Switch';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type SwitchProps = ComponentPropsWithoutRef<typeof MuiSwitch>;
type SwitchRef = ComponentRef<typeof MuiSwitch>;

const Switch = forwardRef<SwitchRef, SwitchProps>((props, ref) => {
  return <MuiSwitch ref={ref} {...props} />;
});

Switch.displayName = 'Switch';
export default Switch;